import { InjectionToken, Provider, ProviderToken } from '@angular/core';
import { IrisInMemoryStorage } from './in-memory-storage';
import { IrisStorageKeyContainer } from './storage-key';
import { IrisUrlStorage } from './url-storage';
import { IrisValueAutoSaver, IrisValueAutoSaverSource, valueAutoSaverFactory } from './value-auto-saver';
import { IrisValueStorage, valueStorageFactory } from './value-storage';

export function createUrlValueAutoSaverProviders<T>(
  valueDescription: string,
  inMemoryStorageKeyContainerToken: ProviderToken<IrisStorageKeyContainer>,
  urlStorageKeyContainerToken: ProviderToken<IrisStorageKeyContainer>,
  valueSourceToken: ProviderToken<IrisValueAutoSaverSource<T>>,
  autoSaverToken: InjectionToken<IrisValueAutoSaver<T>>,
): Provider[] {
  const inMemoryStorage = new InjectionToken<IrisValueStorage<T>>(`${valueDescription}: In-memory storage`);
  const urlStorage = new InjectionToken<IrisValueStorage<T>>(`${valueDescription}: Url storage`);

  return [
    {
      provide: urlStorage,
      useFactory: valueStorageFactory<T>(IrisUrlStorage, urlStorageKeyContainerToken),
    },
    {
      provide: inMemoryStorage,
      useFactory: valueStorageFactory<T>(IrisInMemoryStorage, inMemoryStorageKeyContainerToken),
    },
    {
      provide: autoSaverToken,
      useFactory: valueAutoSaverFactory(valueSourceToken)
        .setStorage(inMemoryStorage)
        .setStorage(urlStorage),
    },
  ];
}
